import type { Socket } from 'socket.io-client'
import { io } from 'socket.io-client'
import config from 'constants/config'
import type { SocketEventHandlers } from '@luxuryescapes/contract-search'

/**
 * Leaf module for the global search socket connection.
 * Kept out of initialiseSearchSocket so socketEmitter can access the socket
 * without the socketEmitter ↔ initialiseSearchSocket cycle.
 */
export let globalSearchSocket: Socket<SocketEventHandlers> | undefined = undefined
export const SEARCH_STREAMING_PAGE_SIZE = 4

let searchSocketDisconnectTimeout: ReturnType<typeof setTimeout> | undefined = undefined

function forceDisconnectSearchSocket() {
  if (!globalSearchSocket) return
  globalSearchSocket.disconnect()
  globalSearchSocket = undefined
}

export function getSearchSocket() {
  if (searchSocketDisconnectTimeout) {
    clearTimeout(searchSocketDisconnectTimeout)
    searchSocketDisconnectTimeout = undefined
  }

  if (globalSearchSocket?.active) {
    return globalSearchSocket
  }

  forceDisconnectSearchSocket()

  const protocol = config.SCHEME === 'http' ? 'ws' : 'wss'
  const uri = `${protocol}://${config.API_HOST}`

  globalSearchSocket = io(uri, {
    transports: ['websocket'],
    path: '/api/search/stream',
  })

  return globalSearchSocket
}

export function disconnectSearchSocket() {
  if (searchSocketDisconnectTimeout) {
    clearTimeout(searchSocketDisconnectTimeout)
  }
  searchSocketDisconnectTimeout = setTimeout(() => {
    forceDisconnectSearchSocket()
    searchSocketDisconnectTimeout = undefined
  }, 5000)
}
